import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isEmptyOptions',
})
export class IsEmptyOptionsPipe implements PipeTransform {
  public transform(value: { id: string; value: any }[]): boolean {
    if (value?.length === 0) {
      return true;
    }

    return value?.every((item) => {
      return item.id === 'empty';
    });
  }
}
